import React from "react";
import { Link, NavLink } from "react-router-dom";
import auth from "../../firebase.init";
import { signOut } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";

const Navber = () => {
  const [user] = useAuthState(auth);
  return (
    <div class="navbar  bg-cyan-800 text-white text-xl">
      <div class="navbar-start ">
        <div class="dropdown ">
          <label tabindex="0" class="btn btn-ghost lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h8m-8 6h16"
              />
            </svg>
          </label>
          <ul
            tabindex="0"
            class="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
          >
            <li>
              <NavLink
                className={({ isActive }) =>
                  isActive ? "text-white" : "text-black mr-4"
                }
                to="/"
              >
                Home
              </NavLink>
            </li>
            <li>
              <Link className="mr-4" to="/blogs">
                Blogs
              </Link>
            </li>
            <li>
              <NavLink className="mr-4" to="/portfolio">
                Portfolio
              </NavLink>
            </li>
            <li className="text-orange-500">
              {user?.uid && (
                <>
                  <NavLink className="mr-4" to="/dashboard">
                    DashBoard
                  </NavLink>
                </>
              )}
              {user ? (
                <button onClick={() => signOut(auth)}>Log out</button>
              ) : (
                <NavLink to="/login">Login</NavLink>
              )}
            </li>
          </ul>
        </div>
        <a class="btn btn-ghost normal-case text-xl">AirCool</a>
      </div>
      <div class="navbar-center hidden  lg:flex">
        <ul class="menu menu-horizontal p-0">
          <li className="mr-4 hover:bg-cyan-800 rounded">
            <NavLink
              className={({ isActive }) =>
                isActive ? "text-white" : "text-black"
              }
              to="/"
            >
              Home
            </NavLink>
          </li>
          <li className="mr-4  hover:bg-cyan-800 rounded">
            <NavLink
              className={({ isActive }) =>
                isActive ? "text-white" : "text-black"
              }
              to="/blogs"
            >
              Blogs
            </NavLink>
          </li>
          <li className="mr-4  hover:bg-cyan-800 rounded">
            <NavLink
              className={({ isActive }) =>
                isActive ? "text-white" : "text-black"
              }
              to="/portfolio"
            >
              Portfolio
            </NavLink>
          </li>
          <li className="mr-4 hover:bg-cyan-800 rounded">
            {user?.uid && (
              <>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? "text-white" : "text-black"
                  }
                  to="/dashboard"
                >
                  DashBoard
                </NavLink>
              </>
            )}
            {user ? (
              <button
                className={({ isActive }) =>
                  isActive ? "text-white" : "text-black"
                }
                onClick={() => signOut(auth)}
              >
                Log out
              </button>
            ) : (
              <NavLink to="/login">Login</NavLink>
            )}
          </li>
        </ul>
      </div>
      <div className="navber-end">
        <label
          tabindex="1"
          for="dashboard-sidebar"
          class="btn btn-ghost lg:hidden"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h8m-8 6h16"
            />
          </svg>
        </label>
      </div>
    </div>
  );
};

export default Navber;
